import React from 'react';
import { Col } from 'reactstrap';
import moment from 'moment';
import capitalize from 'lodash/capitalize';

import { useDocumentTitle } from '../../../hooks';
import { PaymentSummarySpan as Span, Prices, WhitePanel } from '../../../components';

type Props = {
  lineItem: Object,
  /**
   * amount: amount on invoice - invoice.amount
   */
  amount: string,
  rate: string,
  discount: string,
};

export default function Summary(props: Props) {
  const {
    lineItem: {
      lodge: { name, address, services },
      pax,
      currency,
      roomType,
      paymentPlan,
      checkinDate,
      checkoutDate,
    },
    amount,
    rate,
    discount,
  } = props;

  const formatDate = date => moment(date).format('D MMM YYYY');
  const humanReadableDate = `${formatDate(checkinDate)} to ${formatDate(checkoutDate)}`;

  useDocumentTitle(`Lodge Payment | ${name || ''}`, name);

  return (
    <Col lg="6" className="trek-summary">
      <WhitePanel>
        <h2>LODGE SUMMARY</h2>
        <p className="date">{humanReadableDate}</p>
        <p className="lodge-name">
          {name}, {address}
        </p>
        <ul className="service-list">
          <Span title="No. of People" value={pax} />
          <Span
            title="Payment Plan"
            value={paymentPlan === 'N' ? 'Non-Refundable' : 'Refundable'}
          />
          <Span title="Room Type" value={capitalize(roomType)} />
          <Span
            title="Service Level"
            value={services ? services.map(capitalize).join(' | ') : null}
          />
        </ul>
        <hr />
        <Prices
          discount={discount}
          basePrice={rate}
          grandTotal={amount}
          currency={currency}
        />
      </WhitePanel>
    </Col>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Payment/Summary.js